// extracted by mini-css-extract-plugin
module.exports = {"head":"cobasiCuida_head__WWA0w","illustration":"cobasiCuida_illustration__4xsZf","content":"cobasiCuida_content__C6ixZ","description":"cobasiCuida_description___9pL2"};